import './tab-navigation.scss';
import { getOffset } from '../../utilities/js/helper';
import ScrollToTarget from '../../utilities/js/scroll-to';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class TabNavigation {
    constructor ($element) {
        this.$tabNavigation = $element;
        this.$tabNavigationSlider = this.$tabNavigation.querySelector('.tab-navigation__container');
        this.$modules = document.querySelectorAll('[data-aria-label]');
        this.type = this.$tabNavigation.getAttribute('data-tab-navigation-type');
        this.$tabItems = [];
        this.slider = null;
        this.scroller = new ScrollToTarget();
    }

    initialize () {
        if (this.type === 'tab') {
            if (this.$modules.length > 0) {
                this.setTabItems();
                this.setEvents();
                this.checkModuleVisibility();
                this.initSlider();
            }
        } else {
            this.initSlider();
        }
    }

    setTabItems () {
        for (let i = 0; i < this.$modules.length; i++) {
            const $module = this.$modules[i];
            const moduleLabel = $module.getAttribute('data-aria-label');
            const imagePath = $module.dataset.tabNavImage;
            const $tabNavigationItemsContainer = this.$tabNavigation.querySelector('.tab-navigation__items');
            const $navigationItem = document.createElement('li');

            $navigationItem.classList.add('tab-navigation__item');
            $navigationItem.setAttribute('data-module', moduleLabel);
            $navigationItem.setAttribute('data-slide', i);
            $navigationItem.innerHTML = moduleLabel;

            if (typeof imagePath !== 'undefined') {
                if (imagePath !== '') {
                    const $span = document.createElement('span');
                    $span.classList.add('tab-navigation__item-image');
                    const $img = document.createElement('img');
                    $img.src = imagePath;
                    $img.alt = moduleLabel;
                    $span.appendChild($img);
                    $navigationItem.appendChild($span);
                    $navigationItem.classList.add('has--image');
                    this.$tabNavigation.classList.add('has--image');
                }
            }

            $tabNavigationItemsContainer.appendChild($navigationItem);
            this.$tabItems.push($navigationItem);
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$tabNavigationSlider, {
            modules: [Pagination],
            slidesPerView: 'auto',
            spaceBetween: 16,
            initialSlide: 0,
            speed: 1000,
            slideClass: 'tab-navigation__item',
            wrapperClass: 'tab-navigation__items',
            pagination: {
                el: '.tab-navigation__slider',
                type: 'progressbar'
            },
            on: {
                sliderMove: () => {
                    const $swiperSlider = this.$tabNavigation.querySelector('.tab-navigation__slider');
                    $swiperSlider.classList.add('is--active');
                },
                touchEnd: () => {
                    const $swiperSlider = this.$tabNavigation.querySelector('.tab-navigation__slider');
                    setTimeout(() => {
                        $swiperSlider.classList.remove('is--active');
                    }, 750);
                }
            }
        });
    }

    setEvents () {
        for (let i = 0; i < this.$tabItems.length; i++) {
            const $tabItem = this.$tabItems[i];
            $tabItem.addEventListener('click', () => {
                this.setActiveTab($tabItem);
                const moduleLabel = $tabItem.getAttribute('data-module');
                this.scrollToModule(moduleLabel);
            });
        }

        window.eventScroller.customFunctions.push(() => {
            this.checkModuleVisibility();
            this.checkStickyness();
        });
    }

    checkModuleVisibility () {
        let visibilityCounter = 0;
        for (let i = 0; i < this.$modules.length; i++) {
            const $module = this.$modules[i];
            const isInView = this.isInViewport($module);

            if (isInView) {
                const moduleLabel = $module.getAttribute('data-aria-label');
                const $tabItem = this.$tabNavigation.querySelector('[data-module="' + moduleLabel + '"]');
                if ($tabItem) {
                    this.setActiveTab($tabItem);
                }
                visibilityCounter++;
            }
        }

        if (visibilityCounter === 0) {
            this.setActiveTab();
        }
    }

    setActiveTab (activeTabItem) {
        for (let i = 0; i < this.$tabItems.length; i++) {
            const $tabItem = this.$tabItems[i];
            if ($tabItem === activeTabItem) {
                $tabItem.classList.add('is--active');
                const tabSlide = $tabItem.getAttribute('data-slide');
                if (tabSlide && this.slider) {
                    this.slider.slideTo(tabSlide, 500);
                }
            } else {
                $tabItem.classList.remove('is--active');
            }
        }
    }

    scrollToModule (moduleLabel) {
        const $module = document.querySelector('[data-aria-label="' + moduleLabel + '"]');
        const scrollPosition = getOffset($module).top; // not correct position sometimes
        const tabNavigationHeight = this.$tabNavigation.offsetHeight;
        const windowWidth = window.innerWidth;
        let buffer = 64;
        if (windowWidth < 768) {
            buffer = 40;
        }
        const scrollTo = scrollPosition - tabNavigationHeight - buffer;
        this.scroller.scrollTo(scrollTo, 400, 'easeInOutQuart', 0);
    }

    isInViewport (element) {
        const rect = element.getBoundingClientRect();
        const elementScrollTop = rect.top;

        if ((window.innerHeight - elementScrollTop) > (window.innerHeight / 3) && (elementScrollTop + (window.innerHeight / 3) > 0)) {
            return true;
        } else {
            return false;
        }
    }

    checkStickyness () {
        const $observedElement = document.querySelector('.tab-navigation__top');
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio === 0) {
                this.$tabNavigation.classList.add('is--sticky');
            } else if (entries[0].intersectionRatio === 1) {
                this.$tabNavigation.classList.remove('is--sticky');
            }
        }, {
            threshold: [0, 1]
        });

        observer.observe($observedElement);
    }
}

export { TabNavigation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $tabNavigations = $context.querySelectorAll('[data-tab-navigation]');
        if ($tabNavigations.length > 0) {
            $tabNavigations.forEach((tabNavigation) => {
                const $tabNavigation = new TabNavigation(tabNavigation);
                $tabNavigation.initialize();
            });
        }
    }
});
